export const TREND_PATH = "Trend";
export const TREND_MENU_PATH = `${TREND_PATH}/TrendMenu`;
export const FREQUENCY_TREND_SIGNAL_PATH = `${TREND_MENU_PATH}/FrequencyTrendSignals`;
export const TREND_ASSET_SELECTOR_PATH = `${TREND_MENU_PATH}/TrendAssetSelector`;
export const TREND_SIGNAL_SETTINGS_PATH = `${TREND_MENU_PATH}/TrendSignalSettings`;
export const ADVANCED_SETTINGS_DRAWER_PATH = `${TREND_MENU_PATH}/AdvancedSettingsDrawer`;
export const CUSTOM_DOMAIN_PATH = `${ADVANCED_SETTINGS_DRAWER_PATH}/CustomDomain`;
export const STRATIFICATION_PATH = `${ADVANCED_SETTINGS_DRAWER_PATH}/Stratification`;
